import { useQueryClient } from '@tanstack/react-query';
import * as React from 'react';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { DevCommands } from '@/scopes/common/components/DevTools/DevCommands';

export function DevTools() {
  const localQueryClient = useQueryClient();

  if (process.env.NODE_ENV !== 'development') return null;

  return (
    <>
      <ReactQueryDevtools client={localQueryClient} initialIsOpen={false} />
      <DevCommands />
    </>
  );
}
